import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { TabsStyle } from "./tabs.style";
import { useAxios } from "../../../utils/useAxios";
import { useEffect, useState } from "react";
import { FormDataProvider } from "../../../context/FormDataContext";
import FormBuildTabs from "../../formBuilder/FormBuildTabs";
import TabLoading from "../../../Loaders/tabsLoading";
import FormSplite from "../../formSplite/FormSplite";
import { useSearchParams } from "react-router";
import { bsDecrypt } from "../../../utils/storage";
import { decryptObject } from "../../../utils/crypt";
interface Props {
  tabsRes: any;
  formAction?: any;
}

export default function MuiTabsForm({ tabsRes, formAction }: Props) {
  const [value, setValue] = useState(0);
  const [tabsDetails, setTabsDetails] = useState("");
  const [sourceData, setSourceData] = useState(null);
  // const [list, setList] = useState(0);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const encryptedId = searchParams.get("id");
    if (encryptedId) {
      // Only attempt decryption if 'id' parameter exists
      const decrypted = decryptObject(encryptedId);
      setSourceData(decrypted);
    } else {
    }
  }, [searchParams]);

  useEffect(() => {
    if (tabsRes.length > 0) {
      setTabsDetails(tabsRes[0]);
    }
  }, [tabsRes]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setTabsDetails(tabsRes[newValue]);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {sourceData ? (
        <TabsStyle value={value} onChange={handleChange}>
          {tabsRes.map((tab: any, index: number) => (
            <Tab key={tab.id} label={tab.title} />
          ))}
        </TabsStyle>
      ) : (
        <>
          {tabsRes.length > 0 && (
            <TabsStyle value={value} onChange={handleChange}>
              <Tab label={tabsRes[0].title} />
            </TabsStyle>
          )}
        </>
      )}

      <Box p={2} sx={{ background: "#fff", border: "1px solid #d6d4e1" }}>
        {/* <FormDataProvider> */}
        <FormSplite
          tabsDetails={tabsDetails}
          source={sourceData}
          formAction={formAction}
          // list={list}
        />
        {/* </FormDataProvider> */}
      </Box>
    </Box>
  );
}
